import { render, staticRenderFns } from "./MapperFeature.vue?vue&type=template&id=60f8e298&scoped=true&"
import script from "./MapperFeature.vue?vue&type=script&lang=js&"
export * from "./MapperFeature.vue?vue&type=script&lang=js&"
import style0 from "./MapperFeature.vue?vue&type=style&index=0&id=60f8e298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8e298",
  null
  
)

export default component.exports